export default __webpack_public_path__ + "static/media/recruiter-tag.d09e42d6.png";